import { render, staticRenderFns } from "./userApp.vue?vue&type=template&id=18031e41&"
var script = {}
import style0 from "./userApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports